module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Regular-Alphabetic.55cd8fcd.woff2";